import React, { useEffect, useState } from "react";
import { FaTimesCircle } from "react-icons/fa"; 
import ColorInit from "../../../shared/layout/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import Header from "../../../shared/layout/Header";
import Footer from "../../../shared/layout/Footer";
import { CartProvider } from "../../cart/context/CartContext";
import BottomFooter from "../../../shared/layout/BottomFooter";

const ReturnCancelPage = () => {
  const [, setOrderId] = useState(null);
  const [timeLeft, setTimeLeft] = useState(60);

  // Retrieve the orderId from sessionStorage
  useEffect(() => {
    const storedOrderId = sessionStorage.getItem("orderId");
    if (storedOrderId) {
      setOrderId(storedOrderId);
    } else {
      window.location.href = "/";
    }
  }, []);

  // Countdown timer for 60 seconds to auto redirect
  useEffect(() => {
    const countdown = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(countdown);
          handleClick(); // Auto redirect when the timer hits 0
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(countdown);
  }, []);

  // Click handler to clear session storage and redirect to the home page
  const handleClick = () => {
    sessionStorage.removeItem("orderId");
    sessionStorage.removeItem("onePayTransactionId");
    sessionStorage.removeItem("paymentResult");
    window.location.href = "/";
  };

  return (
    <CartProvider>
      <ColorInit color={"bigmall"} />
      <ScrollToTop smooth color="#ef253c" />
      <Header />
      <div className="checkout-sidebar">
        <div className="bg-color-three rounded-8 p-24 text-center">
          <h2 className="text-gray-900 text-xl fw-semibold">Payment Status</h2>
        </div>

        <div className="border border-gray-100 rounded-8 px-24 py-40 mt-24 text-center">
          <div className="mb-24">
            <FaTimesCircle size={60} color="red" />
          </div>
          <p className="text-gray-900 fw-medium text-lg mb-24">
            Your payment has been cancelled.
          </p>
          <div className="mt-24">
            <p className="text-gray-700 text-sm">
              Redirecting in <strong>{timeLeft}</strong> seconds...
            </p>
          </div>
          <div className="mt-24">
            <button onClick={handleClick}>
              Click here to return to home
            </button>
          </div>
          <div className="mt-32">
            <p className="text-gray-700 text-sm">
              Please try again or contact support for assistance.
            </p>
          </div>
        </div>
      </div>
      <Footer />
      <BottomFooter />
    </CartProvider>
  );
};

export default ReturnCancelPage;
